export const embedSources = ['youtube', 'vimeo']; // naudojamas widgetu settingu optionams ir jsx atsirinkimui pagal source
export function getYoutubeId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11)
        ? match[2]
        : null;
}
export function getVimeoId(url = '') {
    const val = url;
    const vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
    const parsed = val.match(vimeoRegex);
    return parsed === null || parsed === void 0 ? void 0 : parsed.at(1);
}
